import { useSelector } from 'react-redux'
import { useQuery } from 'react-query'
import { useAuth0 } from '../../../contexts/auth0-context'
import endpoints from '../../../API/endpoints'
import callAPI from '../../../API/callSecureAPI'
import { CardData } from '../../components/MetricsCards/types'
import { useIsMarketMode } from '../../hooks/useIsMarketMode'

const FIVE_MINUTES = 1000 * 60 * 5

export const useGetImpactMetricsQuery = () => {
    const { getTokenSilently, isAuthenticated, isLoading } = useAuth0()
    const { selectedMarket } = useIsMarketMode()

    // @ts-expect-error store is not typed properly
    const strategyId = useSelector((state) => state.strategy?._id)

    const getImpactMetrics = async () => {
        try {
            const token = await getTokenSilently?.({ audience: 'https://atlas.aesara.com' })

            const { url, method } = endpoints.getImpactMetrics

            const response = await callAPI(url + strategyId + '/' + selectedMarket, method, token)

            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    return useQuery<CardData[]>(['impactMetrics', strategyId], getImpactMetrics, {
        enabled: !!getTokenSilently && !!isAuthenticated && !isLoading && !!strategyId,
        cacheTime: FIVE_MINUTES,
        staleTime: FIVE_MINUTES,
        retry: 3,
    })
}
